<template>
  <div>
    <headEnterprise></headEnterprise>
    <banner :banner="banner"></banner>
    <enterTitle></enterTitle>
    <div class="w80 mb-60 mt-30">
      <el-container>
        <el-aside width="330px">
          <base-info @onCollection="goCollection(7)" :shareObj="detail"></base-info>
          <!-- <div class="saide_middle">
            <div class="saide_mater">
              <p>产品分类</p>
            </div>
            <div class="saide_tree">
              <el-tree
                :data="data"
                show-checkbox
                node-key="id"
                :default-expanded-keys="[2, 3]"
                :default-checked-keys="[1]"
                :props="defaultProps"
              >
              </el-tree>
            </div>
          </div> -->
        </el-aside>
        <el-main>
		      <contTitle :obj="obj" :contTitle="contTitle"></contTitle>
          <div class="mt-30">
            <div class="list fdw">
              <div class="demand_list"   @click="toDetail(item)" v-for="(item,index) in list" :key="index">
                <p class="list_title">{{item.title}}</p>
                <div class="fdc list_text">
                  <p>{{item.createDate}}</p>
                  <p><span>浏览数：</span><span> {{item.readcount}}</span></p>
                </div>
              </div>
            </div>

            <!--分页-->
            <Pagination v-show="total>0"   :total="total"  :page.sync="listQuery.curPage" :limit.sync="listQuery.limit" @pageChange="pageChange" ></Pagination>
            <div style="margin-top:20%;">
                <notList :notCode="notCode"></notList>
            </div>
          </div>
        </el-main>
      </el-container>
    </div>
    <footCom></footCom>
  </div>
</template>
<script>
import{addCollection} from "@/api/coment"
import {getDemandList} from '@/api/information';
import footCom from "../../common/footCom";
import headEnterprise from "../../common/headEnterprise"
import banner from "../../common/banner";
import contTitle from "../../common/contTitle";
import baseInfo from "@/components/companyintroCard";
import Pagination from '../../components/Pagination';
import notList from '../../common/notList'
import enterTitle from '../../common/enterTitle'
export default {
  components: {footCom,headEnterprise, banner,contTitle ,baseInfo,Pagination,notList,enterTitle},
  data() {
    return {
	  contTitle:"企业需求",
      banner: {
        title: "企业需求",
        isShow: false,
        isColor: true,
        type:'',
        usertype:'',
        companytype:'',
        bannerUrl:'',
      },
      obj:{
         title: "企业需求"
      },
      // data: [],
	// defaultProps:{
	 // children: "children",
	 // label: "name"
	// },
      listQuery: {
        curPage: 1,
        limit: 9,
      },
      total:0,
      userid:"",
      detail:"",
      list:[],
	  notCode:false
    };
  },
  created(){
     this.userid = sessionStorage.getItem("corporateId");   
     this.$store.dispatch("company/getBaseInfo"); 
     if(this.userid != null && this.userid != undefined){
       this.getDemandList();
     }  
  },
  computed: {
    userInfo() {
      return this.$store.getters.companyInfo;
    }
  },
  watch: {
    userInfo: {
      handler: function (val, oldVal) {
        if (val.userId) {
          this.banner.bannerUrl = val.banner;
        }
      },
      immediate: true,
    },
  },
  methods: {
	//跳转详情
    toDetail(item){
      this.$router.push({
        path:"/demand_detail",
        query:{id:item.id}
      })
    },
	//查询需求列表
    getDemandList(){ 
      getDemandList({
        ...this.listQuery,
        userid:this.userid
      }).then(res =>{
        if(res.code ==0){
           this.list = res.data.list;
           this.total = res.data.totalCount;
		   this.list.length == 0 ? this.notCode = true : this.notCode = false;
        }
      }).catch((err)=>{})
    },
    //分页
    pageChange(item){
        this.listQuery['curPage'] = item.page;
        this.listQuery['limit'] = item.limit;
        this.getDemandList();
     },
    //产品收藏
    goCollection(goodsType){     
      let params ={
        goodsId:this.id,
        goodsType:goodsType
      }
      addCollection(params).then((res)=>{
        if(res.code ==0){
          this.$message({
            message: '收藏成功！',
            type: 'success'
          });
        }
      }).catch((err)=>{})
    },
  },
};
</script>
<style scoped>
.el-aside {
  background: white;
  height: auto;
  /* border: 1px solid red; */
}
.aside_left {
  height: 532px;
  background: #ffffff;
  border: 1px solid #ededed;
  padding: 20px 20px;
}
.left_top {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.portrait {
  width: 107px;
  height: 107px;
  background: #ffffff;
  border: 1px solid #ededed;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.portrait img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
.wire {
  margin-top: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #999999;
}
.wire p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.left_bat {
  text-align: left;
  margin-top: 20px;
  margin-left: 30px;
}
.left_bat p {
  align-items: baseline;
}
.left_bat p span:first-child {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
}
.left_bat p span:last-child {
  flex: 1;
  margin-left: 10px;
  margin-right: 20px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
.left_far {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 15px;
}
.left_far img {
  width: 17px;
  height: 16px;
  margin-right: 10px;
}
.left_bartext {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

.saide_middle {
  margin-top: 30px;
  background: #f8f8f8;
  color: #333;
  text-align: center;
  border-top: 2px solid #99cf2a;
  padding: 15px 15px;
  text-align: left;
}
.saide_mater {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px dashed #e1e1e1;
}
.saide_mater p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}
.saide_mater span {
  cursor: pointer;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}

.el-tree {
  background: #f8f8f8;
}

/* .wires {
  border-bottom: 1px solid #eeeeee;
  margin-top: 20px;
} */
.list{
  justify-content: left;
}
.demand_list {
  width: 32%;
  margin-right: 2%;
  height: 120px;
  background: #fbfbfb;
  border: 1px solid #dedede;
  font-family: Microsoft YaHei;
  font-weight: 400;
  padding: 15px 20px;
  text-align: left;
  cursor: pointer;
  margin-bottom: 15px;
}
.demand_list:nth-child(3n){
  margin-right: 0;
}
.list_title {
  font-size: 16px;
  color: #333333;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  height: 42px;
}
.list_text {
  margin-top: 20px;
  font-size: 14px;
  color: #999999;
}

.el-pagination {
  margin-top: 40px;
}

.mt-10 {
  margin-top: 10px;
}
.mt-20 {
  margin-top: 20px;
}
.mb-60 {
  margin-bottom: 60px;
}
</style>



// WEBPACK FOOTER //
// src/view/company/corporate_demand.vue